import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import React, { Component } from 'react'
import { Field, reduxForm, formValueSelector, SubmissionError } from 'redux-form'
import RecaptchaForm from 'components/recaptcha/recaptcha_form'
import { connect } from 'react-redux'

import loginActions from 'redux/actions/loginActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import LoginHeader from 'views/login/header/login_header'
import TextInputForm from 'components/input/text/text_input_form'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import { localize } from 'helpers/translator'
import { validateEmail } from 'helpers/validations'

import styles from './login_forgot_password.scss'

const validate = values => {
	const errors = {}
	if (!values.email) {
		errors.email = localize('global_form_emailIsRequired')
	} else if (!validateEmail(values.email)) {
		errors.email = localize('global_form_invalidEmail')
	}
	return errors
}
let captcha

class LoginForgotPassword extends Component {

	constructor() {
		super()
		this.getFieldStatus = this.getFieldStatus.bind(this)
		this.getFieldMessage = this.getFieldMessage.bind(this)
	}

	getFieldStatus(field) {
		if (field.touched && field.error) {
			return 'error'
		} else {
			return ''
		}
	}

	getFieldMessage(field) {
		return field.error
	}

	render() {
		const {
			handleSubmit,
			submitting } = this.props

		const handleForgotPasswordSubmit = values => new Promise(
			(resolve, reject) => {
				this.props.actions.sendForgotPasswordForm(
					values,
					resolve,
					reject,
				)
			})
			.catch(function(err) {
				captcha.getRenderedComponent().reset()
				throw new SubmissionError({...err})
			})

		return (
			<div styleName='wrapper'>
				<div styleName='header'>
					<LoginHeader linkType='login' />
				</div>
				<main styleName='main'>
					<article styleName='content'>
						<header styleName='content-header'>
							<h1 styleName='content-header-title'>{localize('teachers_title')}</h1>
							<h2 styleName='content-header-subtitle'>{localize('forgotPassword_title')}</h2>
						</header>
						<p styleName='content-description'>
							{`${localize('forgotPassword_explanation_start')} `}
							<b styleName='content-description-bold'>{localize('forgotPassword_explanation_bold')}</b>
							{` ${localize('forgotPassword_explanation_end')}`}
						</p>
						<form styleName='content-form' onSubmit={handleSubmit(handleForgotPasswordSubmit)}>
							<div styleName='content-form-field'>
								<Field
									name="email"
									component={TextInputForm}
									type="text"
									props={{
										placeholder: localize('global_form_email'),
										icons: {active: true},
										fieldStatus: this.getFieldStatus,
										getMessage: this.getFieldMessage,
									}}
								/>
							</div>
							<div styleName='content-form-captcha'>
								<Field
									component={RecaptchaForm}
									name="recaptcha"
									withRef={true}
									ref={el => {
										captcha = el
									}}
									props={{
										getMessage: this.getFieldMessage,
									}}
								/>
							</div>
							<div styleName='content-form-button'>
								<MainButton
									type='submit'
									pill={true}
									disabled={
										submitting ||
										this.props.button_disabled
									}
								>
									{localize('global_submit')}
								</MainButton>
							</div>
						</form>
						<p styleName='content-text'>
							{`${localize('forgotPassword_forgotEmail')} `}
							<TextLink
								styleName='content-text-link'
								href='mailto:support@nearpod.com'
							>
								support@nearpod.com
							</TextLink>
						</p>
					</article>
				</main>
			</div>
		)
	}

}

LoginForgotPassword.propTypes = {
	actions: PropTypes.object,
	handleSubmit: PropTypes.func.isRequired,
	submitting: PropTypes.bool.isRequired,
	button_disabled: PropTypes.bool,
}

function mapStateToProps(state) {
	const selector = formValueSelector('ForgotPassword')
	const recaptcha = selector(state, 'recaptcha')
	return {
		button_disabled: !recaptcha,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		sendForgotPasswordForm: loginActions.sendForgotPasswordForm,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: 'ForgotPassword',
	fields: ['email', 'recaptcha'],
	validate,
})(CSSModules(LoginForgotPassword, styles, {allowMultiple: true})))
